import React, { FC } from 'react';
import classNames from 'classnames/bind';
import { Text } from '@carnica/ui-kit';

import { GroupRightSide } from './GroupRightSide';
import styles from './styles.pcss';

const cn = classNames.bind(styles);

type GroupContentProps = {
  avatarImage: string;
  isError: boolean;
  items: any;
  status: any;
  subTitle: string;
  title: string;
};

export const GroupContent: FC<GroupContentProps> = ({
  title,
  subTitle,
  isError,
  items,
  status,
  avatarImage,
}) => (
  <div className={cn('container')}>
    <div className={cn('title-block')}>
      <Text className={cn('title')} size="xs">
        {title}
      </Text>
      {!!subTitle && (
        <Text color="secondary" size="xs">
          {subTitle}
        </Text>
      )}
    </div>
    <GroupRightSide avatarImage={avatarImage} isError={isError} items={items} status={status} />
  </div>
);
